// ✅ Version robuste complète
const track = document.getElementById('track');
if (track) {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  
  if (mq.matches) track.style.animationPlayState = 'paused';
  
  mq.addEventListener('change', e => {
    track.style.animationPlayState = e.matches ? 'paused' : 'running';
  });
}